import { SOCKET_EVENTS } from '@constants';
import { IUser } from '@sdk/contracts';
import { useCallback, useEffect } from 'react';

import { useSocket } from '@/hooks';
import { useProfile } from '@/store';

export const UserUpdateHandler = () => {
  const { profile, refetch } = useProfile();
  const { on, off } = useSocket();

  const handleUpdateUser = useCallback(
    (user: IUser) => {
      if (user._id !== profile?._id) return;
      refetch();
    },
    [profile, refetch]
  );

  useEffect(() => {
    on(SOCKET_EVENTS.UPDATE_USER, handleUpdateUser);
    return () => {
      off(SOCKET_EVENTS.UPDATE_USER, handleUpdateUser);
    };
  }, [profile, handleUpdateUser, off, on]);
  return null;
};
